import { graphql } from '@/graphql/generated/seller';

export const ordersQuery = graphql(`
  query OrdersQuery(
    $limit: Int!
    $offset: Int!
    $where: OrdersBoolExp!
    $orderBy: [OrdersOrderByExp!]!
  ) {
    orders(limit: $limit, offset: $offset, where: $where, order_by: $orderBy) {
      id
      name
      reference
      accountId
      status
      currency
      channelId
      channelName
      customerName
      qtyOrdered
      totalPrice
      createdAt
      orderedAt
      orderHolds {
        id
        type
        subtype
        description
        createdAt
      }
    }
    ordersAggregate(filter_input: { where: $where }) {
      _count
    }
  }
`);

export const listingsQuery = graphql(`
  query ListingsQuery(
    $limit: Int!
    $offset: Int!
    $where: ListingsBoolExp!
    $orderBy: [ListingsOrderByExp!]!
  ) {
    listings(limit: $limit, offset: $offset, where: $where, order_by: $orderBy) {
      id
      name
      description
      externalSkuName
      status
      qtyExpected
      qtyAvailable
      listingStrategy
      qtyListed
      channelName
      createdAt
      updatedAt
    }
    listingsAggregate(filter_input: { where: $where }) {
      _count
    }
  }
`);
